import { combineReducers } from 'redux';
import envInfoReducer from './envInfoReducer';

const rootReducer = combineReducers({
  envInfo: envInfoReducer,
});

export default rootReducer;
